import { m } from '@/lib/paraglide/messages'

// Cột CK là NUMERIC(5,2) nên mức lẻ như 12,5% là giá trị thật. Phải qua locale
// vi-VN: String(12.5) cho dấu chấm, mà dấu chấm cạnh đó đang là phân cách nghìn
// của formatQty — "CK 12.5%" đứng cạnh "1.240 hộp" đọc ra hai nghĩa khác nhau.
const percentFormatter = new Intl.NumberFormat('vi-VN', {
    maximumFractionDigits: 2,
})

/** Nhãn một mức CK đánh dấu của lô. DB coi 0 và "không đánh dấu" là cùng một
 *  trạng thái, nên mức 0 đọc thành "Không CK" chứ không phải "CK 0%". */
export function stockTierLabel(tier: number): string {
    if (tier === 0) return m.product_stock_no_discount()
    return m.product_stock_discount_tier({
        percent: percentFormatter.format(tier),
    })
}

/** Nhãn CK của MỘT lô trên các cuốn sổ (M-129): chỉ có khi lô được đánh dấu CK
 *  (> 0). Lô không đánh dấu thì không có nhãn — sổ không in "Không CK" cạnh mọi
 *  lô thường. */
export function lotDiscountLabel(
    percent: number | null | undefined,
): string | undefined {
    if (percent == null || !Number.isFinite(percent) || percent <= 0) {
        return undefined
    }
    return stockTierLabel(percent)
}
